import api from 'api-client'
import Vue from 'vue'

const state = {
    partners: [],
    contractualContingent: {},
    contractualContingentByEvent: {}
}

const getters = {
    partners: state => state.partners,
    contractualContingent: state => state.contractualContingent,
    contractualContingentByEvent: state => state.contractualContingentByEvent
}

const mutations = {
    setPartners(state, partners) {
        state.partners = partners
    },
    setContractualContingent(state, contingents) {
        state.contractualContingent = contingents;
    },
    setContractualContingentByEvent(state, contingentsByEvent) {
        state.contractualContingentByEvent = contingentsByEvent;
    }
}

const actions = {
    loadPartners({ commit }) {
        return api.getPartners().then(result => {
            commit('setPartners', result)
        })
    },
    loadContractualContingent({ commit }) {
        return api.getContractualContingent().then(result => {
            const contingents = result.reduce((acc, item) => {
                acc[item.name] = item;
                return acc;
            }, {});
            commit('setContractualContingent', contingents);
        }).catch(error => {
            console.error('Error loading contractual contingent:', error);
        });
    },
    loadContractualContingentByEvent({ commit }) {
        return api.getContractualContingentByEvent().then(result => {
            // Log the raw API response
            // console.log('ContractualContingentByEvent API Response:', result);
            
            // Improved data processing to handle undefined event_id
            const contingentsByEvent = {};
            
            // Zuerst alle Elemente nach Event-ID gruppieren
            result.forEach(item => {
                // Skip items with undefined event_id or use a fallback key
                const eventId = item.event_id || item.FK_EventGroup || item.eventId || 'unknown';
                
                if (eventId !== 'unknown') {
                    // Convert eventId to string to ensure compatibility with selectedF1Event
                    const eventIdStr = String(eventId);
                    
                    // Wenn diese Event-ID noch nicht existiert, erstelle ein Array dafür
                    if (!contingentsByEvent[eventIdStr]) {
                        contingentsByEvent[eventIdStr] = [];
                    }
                    
                    // Füge das Item zum Array für diese Event-ID hinzu
                    contingentsByEvent[eventIdStr].push(item);
                }
            });
            
            // Erstelle einen "all"-Eintrag für die Summe aller Kontingente
            contingentsByEvent['all'] = { 
                event_id: 'all',
                contractualContingent: 0,
                contractualTickets: 0
            };
            
            // Berechne die Summen für den "all"-Eintrag
            Object.values(contingentsByEvent).forEach(items => {
                if (Array.isArray(items)) {
                    items.forEach(item => {
                        if (item.contractualContingent) {
                            contingentsByEvent['all'].contractualContingent += Number(item.contractualContingent) || 0;
                        }
                        if (item.contractualTickets) {
                            contingentsByEvent['all'].contractualTickets += Number(item.contractualTickets) || 0;
                        }
                    });
                }
            });
            
            // Log the processed data
            // console.log('ContractualContingentByEvent Processed Data:', contingentsByEvent);
            
            commit('setContractualContingentByEvent', contingentsByEvent);
            return result; // Return the result for external use
        }).catch(error => {
            console.error('Error loading contractual contingent by event:', error);
        });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
} 